/* =============================================================================
 * Embroidery bundle lockdown for OS3 (cart drawer)
 * -----------------------------------------------------------------------------
 * Plain JS, no jQuery. Loaded globally by snippets/embroidery-bundle-lockdown.liquid.
 * Edit THIS file for anything embroidery-cart related on OS3.
 *
 * WHY THIS EXISTS
 *   OS3 clothing embroidery used to add the add-on as a SHARED "counter" product
 *   whose qty was bumped, with the embroidery details stored as properties on the
 *   garment. Nothing linked a garment to its add-on, so removing a garment left a
 *   paid orphan behind and quantities desynced. The legacy drawer qty buttons
 *   (theme-dual-merged.js .plus_icon2 / .minus_icon2) also re-add the add-on from
 *   the garment's "ADD ON" property on every qty change — creating stray add-on
 *   lines with no link. Those legacy handlers are now GATED OFF on OS3 (they early
 *   -return when body.className contains "os3"); this file owns the OS3 flow end
 *   to end instead.
 *
 * WHAT IT DOES
 *   A. Atomic add (capture-phase click interceptor on .add-to-cart): when an
 *      embroidery add-on is selected (#addon set) it adds the garment + its add-on
 *      line(s) in ONE /cart/add.js, linked by a unique _bundle_id. Tracking props:
 *        - garment : "Purchase ID" (visible), _bundle_id + _addon_ids (hidden)
 *        - add-on  : "For Purchase" + "Qty" (visible), _bundle_id (hidden)
 *      Then it clears the embroidery inputs so nothing leaks into the next add.
 *   B. Drawer reconciler (MutationObserver on .cart_drawer_custom): removes orphan
 *      add-ons, repairs/drops broken garments, and keeps each add-on's quantity AND
 *      its "Qty" property in sync with the garment (garment = source of truth).
 *      Acts only on lines carrying a _bundle_id, so legacy carts are untouched.
 *      Reconcile-only: it never touches the checkout button.
 * ========================================================================== */
(function () {
  "use strict";
  if (window.__embBundleLockdown) return;   // singleton guard (loaded globally)
  window.__embBundleLockdown = true;

  // The 5 embroidery add-on VARIANT ids.
  var ADDON_VARIANT_IDS = [45814306570498, 43272026063106, 43272054112514, 43048672166146, 43096458625282];

  // "ADD ON" property value  ->  the add-on variant id(s) it maps to.
  var ADDON_MAP = {
    "Name":               [43048672166146],
    "Sleeve Mate":        [43096458625282],
    "Name + Sleeve Mate": [43272026063106, 43272054112514],
    "Add Logo":           [45814306570498]
  };

  // Embroidery hidden inputs (snippets/os3-forms.liquid). Cleared after each add.
  var INPUT_IDS = ['addon','namePlacement','nameFirstline','nameSecondline','nameColor','logoPlacement','logoName','initials','initialsColor'];

  // ------------------------------------------------------------------ helpers
  function val(id) { var el = document.getElementById(id); return el ? (el.value || "") : ""; }

  // Short, human-readable id shared by a garment ("Purchase ID") and its add-on
  // line(s) ("For Purchase") so staff can match them on the order. No I/O/0/1.
  function makePurchaseId() {
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', out = '';
    for (var i = 0; i < 6; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
    return out;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
  }

  // Is any embroidery add-on line rendered in the drawer DOM right now? Cheap
  // (no network) — used to gate the timer so it only reconciles when there's
  // actually an add-on that could be orphaned.
  function domHasAddonLine() {
    for (var i = 0; i < ADDON_VARIANT_IDS.length; i++) {
      if (document.querySelector('.cart__item[dataid="' + ADDON_VARIANT_IDS[i] + '"]')) return true;
    }
    return false;
  }

  // ================================================================= PART A
  // Atomic embroidery add via a capture-phase click interceptor.
  var submitting = false;

  // Same source Custom.js uses on OS3 (the <select name="id"> the theme keeps in
  // sync with the selected size/colour). Fall back to any [name="id"].
  function resolveVariantId() {
    var sel = document.querySelector('.product-single__variants');
    if (sel && sel.value) return parseInt(sel.value, 10);
    var idInput = document.querySelector('.product-single__form [name="id"], form[action*="/cart/add"] [name="id"], [name="id"]');
    return idInput && idInput.value ? parseInt(idInput.value, 10) : null;
  }

  function clearInputs() {
    // Clear so the next add doesn't inherit this one's embroidery, and so the
    // legacy counter logic (which reads #addon) can never fire with a stale value.
    INPUT_IDS.forEach(function (id) { var el = document.getElementById(id); if (el) el.value = ''; });
  }

  // Return the PDP "Add Embroidery" affordance + modal to their FRESH state after an
  // atomic add. The legacy flow reset this in the counter-logic path our capture-phase
  // interceptor now bypasses; without it the UI stays stuck "configured" and a later
  // add-again (after removing the item) silently drops the embroidery / bugs out.
  function resetEmbroideryUI() {
    var $ = window.jQuery; if (!$) return;
    try {
      $('.tleft, .dollarsign').show();
      $('.tprice').show().html('18 to $30');
      $('.dynadelete').hide();
      $('.addmyname, .addicon').hide();
      $('.addmyname.phantom').hide();
      $('.flyingname, .flyingsub').html('');
      $('#embroiderycheckbox').prop('checked', false);
      $('.embroidery-products').val('');
      $('.embroi-image').css({ 'background-image': '', 'background-color': '' });
      $('.outer-modal').removeClass('showflex').addClass('hideflex');
      $('.outer-modal input[type=text]').val('');
      $('.addname-checkbox, .addicon-checkbox, .addboth-checkbox, .addyouricon-checkbox').prop('checked', false);
      $('#aadd, .badd, .cadd, .eadd').prop('disabled', true);
      $('.image-wrapper.active, .duo-button.active').removeClass('active');
    } catch (e) {}
  }

  function doAtomicAdd(atcBtn, addon) {
    if (submitting) return;
    var variantId = resolveVariantId();
    if (!variantId) return;   // can't safely resolve the garment -> abort (leave the button)
    submitting = true;

    var labelEl = atcBtn.querySelector('[data-add-to-cart-text]') ||
                  atcBtn.querySelector('#addToCartText') ||
                  atcBtn.querySelector('span');
    var prevLabel = labelEl ? labelEl.innerHTML : null;
    if (labelEl) labelEl.textContent = 'Adding...';
    atcBtn.disabled = true;

    var addonIds = ADDON_MAP[addon];
    var bundleId = 'emb_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
    var purchaseId = makePurchaseId();
    var qty = 1;   // current OS3 flow always adds one garment per bundle
    // Only carry "Logo Name" for add-ons that include an icon/logo, else the
    // pre-selected #logoName default leaks (the "Kathy the Koala" bug).
    var withIcon = (addon === 'Sleeve Mate' || addon === 'Name + Sleeve Mate' || addon === 'Add Logo');

    // Display property KEYS match the legacy Custom.js add so the cart looks the same.
    var props = {
      'ADD ON':           addon,
      'Title Placement':  val('namePlacement'),
      'Title Firstline':  val('nameFirstline'),
      'Title Secondline': val('nameSecondline'),
      'Title Color':      val('nameColor'),
      'Logo Placement':   val('logoPlacement'),
      'Logo Name':        withIcon ? val('logoName') : '',
      'initials':         val('initials'),
      'initialsColor':    val('initialsColor'),
      'Purchase ID':      purchaseId,
      '_bundle_id':       bundleId,
      '_addon_ids':       addonIds.join(',')
    };

    var items = [{ id: variantId, quantity: qty, properties: props }];
    addonIds.forEach(function (id) {
      // Order matters for the drawer: "For Purchase" then "Qty" (both visible).
      items.push({ id: id, quantity: qty, properties: { 'For Purchase': purchaseId, 'Qty': String(qty), _bundle_id: bundleId } });
    });

    function restore() {
      if (labelEl && prevLabel != null) labelEl.innerHTML = prevLabel;
      atcBtn.disabled = false;
    }

    // Shopify multi-item add is all-or-nothing: never garment-without-add-on.
    postJSON('/cart/add.js', { items: items })
      .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, json: j }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error((r.json && (r.json.description || r.json.message)) || 'Could not add to cart.');
        restore();
        clearInputs();
        resetEmbroideryUI();      // return the PDP/modal to fresh so add-again works
        refreshAndOpenDrawer();   // re-render + open the drawer, same as today
      })
      .catch(function (err) {
        restore();
        try { window.alert(err.message || 'Sorry, we could not add this item. Please try again.'); } catch (e) {}
      })
      .then(function () { submitting = false; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var atc = t.closest('.add-to-cart');   // whole-token match; socks' .add-to-cart-btn is excluded
    if (!atc) return;
    var addonEl = document.getElementById('addon');
    if (!addonEl) return;                    // not an embroidery-capable form
    var addon = (addonEl.value || '').trim();
    if (!addon || !ADDON_MAP[addon]) return; // no embroidery selected -> let the normal ATC run
    e.preventDefault();
    e.stopImmediatePropagation();
    doAtomicAdd(atc, addon);
  }, true);

  // Own the drawer's qty +/- and Remove for BUNDLE lines on ANY page and whatever theme
  // bundle is loaded. theme.js / theme-dual.js / theme-dual-merged.js all ship legacy
  // ".addonjin" handlers that (on a bundle line) inject a stray add-on or drop the garment
  // without its add-on. Capture-phase + stopImmediatePropagation wins before all of them.
  // Non-bundle (legacy, no data-bundle-id) lines are left to the theme's own handlers.
  var qtyBusy = false;
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var ctrl = t.closest('.plus_icon2, .minus_icon2, .custom_remove_btn');
    if (!ctrl) return;
    var row = ctrl.closest('.cart__item');
    var bid = row && row.getAttribute('data-bundle-id');
    if (!bid) return;                          // legacy/non-bundle line -> theme handler runs
    e.preventDefault();
    e.stopImmediatePropagation();
    if (qtyBusy) return;                        // ignore rapid double-clicks while one is in flight
    qtyBusy = true;
    var qtyInput = row.querySelector('.cart__quantity');
    var lineIdx = qtyInput && qtyInput.getAttribute('data-index');
    var cur = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var isRemove = ctrl.classList.contains('custom_remove_btn');
    var next = isRemove ? 0 : (ctrl.classList.contains('plus_icon2') ? cur + 1 : cur - 1);
    var finish = function () { qtyBusy = false; try { if (typeof window.cart_update === 'function') window.cart_update(); } catch (err) {} };
    if (next <= 0) {
      removeBundle(bid).then(finish, finish);            // drop garment + add-on(s) atomically
    } else {
      if (qtyInput) qtyInput.value = next;
      postJSON('/cart/change.js', { line: lineIdx, quantity: next }).then(finish, finish);  // reconciler syncs the add-on
    }
  }, true);

  // ================================================================= PART B
  // Cart-drawer reconciler.
  function isAddon(it) {
    return ADDON_VARIANT_IDS.indexOf(it.id) !== -1 || ADDON_VARIANT_IDS.indexOf(it.variant_id) !== -1;
  }
  function bundleIdOf(it) { return it.properties && it.properties._bundle_id; }
  function addonIdsOf(it) {
    var s = it.properties && it.properties._addon_ids;
    return s ? String(s).split(',').map(function (x) { return parseInt(x, 10); }).filter(function (n) { return !!n; }) : [];
  }

  var working = false, dirty = false, tmr = null;
  // Backstops so a target that genuinely can't be reached (inventory clamp, persistent
  // 422/5xx) stops re-issuing instead of spinning the reconcile<->refresh loop. Counters
  // track CONSECUTIVE FAILED attempts and are cleared the moment the op converges, so
  // ordinary repeated syncs (e.g. toggling +/-) never exhaust them.
  var syncAttempts = {};    // (bid|variant|want) -> consecutive failed qty-syncs
  var repairAttempts = {};  // bid              -> consecutive failed repairs
  var MAX_SYNC = 4;
  function schedule() { if (tmr) clearTimeout(tmr); tmr = setTimeout(function () { tmr = null; reconcile(); }, 250); }

  function reconcile() {
    if (working) { dirty = true; return; }
    working = true; dirty = false;

    getCart().then(function (cart) {
      if (!cart || !cart.items) return null;

      // Index bundles by _bundle_id. Only lines carrying a _bundle_id participate.
      var mains = {}, addonsByBid = {};
      cart.items.forEach(function (it) {
        var bid = bundleIdOf(it);
        if (!bid) return;
        if (isAddon(it)) { (addonsByBid[bid] = addonsByBid[bid] || []).push(it); }
        else { mains[bid] = it; }
      });

      var bids = {};
      Object.keys(mains).forEach(function (b) { bids[b] = 1; });
      Object.keys(addonsByBid).forEach(function (b) { bids[b] = 1; });

      var ops = [];
      Object.keys(bids).forEach(function (bid) {
        var main = mains[bid];
        var adns = addonsByBid[bid] || [];

        if (!main) {                                    // 1. orphan add-on(s) -> remove
          adns.forEach(function (a) { ops.push({ kind: 'change', key: a.key, qty: 0 }); });
          return;
        }

        var purchaseId = (main.properties && main.properties['Purchase ID']) || '';
        var expected = addonIdsOf(main);                // 2. broken main -> repair (or drop)
        var present = adns.map(function (a) { return a.variant_id || a.id; });
        var missing = expected.filter(function (id) { return present.indexOf(id) === -1; });
        if (missing.length) {
          // Capped like qty-sync: after MAX_SYNC consecutive failed repairs (e.g. a
          // persistent 429/5xx) stop re-issuing so the observer<->refresh loop can't spin.
          if ((repairAttempts[bid] || 0) < MAX_SYNC) {
            ops.push({ kind: 'repair', mainKey: main.key, qty: main.quantity, bid: bid, missing: missing, forPurchase: purchaseId });
          }
          return;
        }
        delete repairAttempts[bid];   // bundle is whole -> clear the repair budget

        adns.forEach(function (a) {                      // 3. qty + "Qty" property sync
          var want = main.quantity;
          var variant = a.variant_id || a.id;
          var qtyProp = (a.properties && a.properties.Qty) || '';
          var aKey = bid + '|' + variant + '|' + want;
          if (a.quantity === want && qtyProp === String(want)) { delete syncAttempts[aKey]; return; }  // aligned -> clear budget
          if ((syncAttempts[aKey] || 0) >= MAX_SYNC) return;   // genuinely stuck -> stop re-issuing
          var props = {};
          if (a.properties) { for (var k in a.properties) { if (a.properties.hasOwnProperty(k)) props[k] = a.properties[k]; } }
          props.Qty = String(want);
          if (purchaseId) props['For Purchase'] = purchaseId;
          props._bundle_id = bid;
          // syncKey/want/variant let runOps decide convergence from the response and
          // reset/increment the counter on the ACTUAL outcome (not merely issuing the op).
          ops.push({ kind: 'change', key: a.key, qty: want, properties: props, syncKey: aKey, want: want, variant: variant, bid: bid });
        });
      });

      // 4. No-_bundle_id add-on lines (strays from the legacy flow, or a legacy cart).
      //    Runs on ANY page -- a bundle can be edited from an OS2 "merged" page whose
      //    body class isn't "os3", which is exactly how a stray gets injected. Reconcile
      //    each add-on VARIANT down to the quantity legit OLD-style garments demand (a
      //    non-addon line with an "ADD ON" property but no _bundle_id); units beyond
      //    that demand are strays -> remove/trim. New-style add-ons carry a _bundle_id
      //    and are handled above, untouched here.
      var legacyDemand = {};
      cart.items.forEach(function (g) {
        if (isAddon(g) || !g.properties || !g.properties['ADD ON'] || g.properties._bundle_id) return;
        (ADDON_MAP[g.properties['ADD ON']] || []).forEach(function (v) { legacyDemand[v] = (legacyDemand[v] || 0) + g.quantity; });
      });
      cart.items.forEach(function (it) {
        if (!isAddon(it) || bundleIdOf(it)) return;      // only no-_bundle_id add-on lines
        var v = it.variant_id || it.id;
        var allow = legacyDemand[v] || 0;
        if (it.quantity > allow) ops.push({ kind: 'change', key: it.key, qty: allow });   // qty 0 removes the line
        legacyDemand[v] = Math.max(0, allow - it.quantity);
      });

      // Cart aligned -> do NOTHING. Never re-render the drawer when nothing changed:
      // a no-op refresh raced cart-drawer-progress.liquid's own debounced rebuild
      // (which moves #shopify-section-drawer-products) and broke its UCPB / upsell.
      if (!ops.length) return null;
      return runOps(ops).then(function () { return true; });
    })
    .then(function (changed) { if (changed) return refreshDrawer(); })
    .catch(function () { /* fail open: never block the shopper */ })
    .then(function () { working = false; if (dirty) schedule(); });
  }

  // Run cart writes sequentially to avoid racing concurrent /cart/*.js calls.
  function runOps(ops) {
    return ops.reduce(function (p, op) {
      return p.then(function () {
        if (op.kind === 'change') {
          var body = { id: op.key, quantity: op.qty };
          if (op.properties) body.properties = op.properties;   // change.js updates props too
          return postJSON('/cart/change.js', body).then(function (res) {
            if (!op.syncKey) return;   // removal/trim (no target) -> no convergence tracking
            // Decide convergence from the actual result so the cap counts only genuine
            // failures (inventory clamp / persistent error) and resets on success.
            return res.json().then(function (cart) {
              var line = (cart.items || []).find(function (it) {
                return (it.variant_id === op.variant || it.id === op.variant) && (it.properties || {})._bundle_id === op.bid;
              });
              var converged = !!line && line.quantity === op.want && (line.properties || {}).Qty === String(op.want);
              if (converged) delete syncAttempts[op.syncKey];
              else syncAttempts[op.syncKey] = (syncAttempts[op.syncKey] || 0) + 1;
            }).catch(function () { syncAttempts[op.syncKey] = (syncAttempts[op.syncKey] || 0) + 1; });
          });
        }
        if (op.kind === 'repair') {
          return op.missing.reduce(function (pp, id) {
            return pp.then(function () {
              return postJSON('/cart/add.js', { items: [{ id: id, quantity: op.qty, properties: { 'For Purchase': op.forPurchase, 'Qty': String(op.qty), _bundle_id: op.bid } }] })
                .then(function (res) { if (!res.ok) { var e = new Error('repair-add-failed'); e.status = res.status; throw e; } });
            });
          }, Promise.resolve()).then(function () {
            delete repairAttempts[op.bid];   // all missing add-ons restored
          }).catch(function (err) {
            // GENUINELY unavailable (422/404) -> drop the garment so the cart stays aligned.
            if (err && (err.status === 422 || err.status === 404)) {
              delete repairAttempts[op.bid];
              return postJSON('/cart/change.js', { id: op.mainKey, quantity: 0 });
            }
            // Transient (429/5xx/network) -> leave the bundle & count it; the build-time
            // cap stops re-issuing after MAX_SYNC so it can't loop; a later pass retries.
            repairAttempts[op.bid] = (repairAttempts[op.bid] || 0) + 1;
          });
        }
        return Promise.resolve();
      });
    }, Promise.resolve());
  }

  // Remove a whole bundle (garment + its add-on line[s]) in ONE atomic /cart/update.js
  // so no priced add-on is ever left billable in the re-rendered drawer. Called by the
  // drawer's garment remove / minus-to-0 handlers (closes the remove->reconcile window).
  function removeBundle(bid) {
    if (!bid) return Promise.resolve();
    return getCart().then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (it) { if (bundleIdOf(it) === bid) updates[it.key] = 0; });
      if (!Object.keys(updates).length) return null;
      return postJSON('/cart/update.js', { updates: updates });
    });
  }

  // ----------------------------------------------------------- drawer render
  function swapInner(doc, sel) {
    var s = doc.querySelector(sel), d = document.querySelector(sel);
    if (s && d) d.innerHTML = s.innerHTML;
  }
  function fetchHome() {
    return fetch('/', { headers: { Accept: 'text/html' }, credentials: 'same-origin' }).then(function (r) { return r.text(); });
  }

  // Silent re-render: the theme's cart_update() body MINUS the drawer-open trigger,
  // so a background reconcile never pops the drawer open.
  function refreshDrawerSilently() {
    return fetchHome().then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      swapInner(doc, '.cart_count_icon');
      var di = document.querySelector('.drawer__inner'); if (di) di.classList.remove('overlay-applied');
      swapInner(doc, '.cart_drawer_custom');
      swapInner(doc, '.unlockmsg');
      reinitDrawerSlick();
    });
  }

  function isDrawerOpen() {
    var d = document.querySelector('#CartDrawer, .drawer--cart');
    return !!(d && d.classList.contains('drawer--is-open')) || document.body.classList.contains('js-drawer-open');
  }

  // Re-render after a reconcile change. When the drawer is OPEN, use the theme's own
  // cart_update() — cart-drawer-progress.liquid reliably rebuilds its UCPB/upsell after it
  // (its rebuild hangs off the drawer-open), whereas a bare .cart_drawer_custom swap does
  // not, which broke the progress/upsell. Re-opening an already-open drawer is a no-op.
  // When the drawer is CLOSED, swap silently (nothing visible to pop open); cart-drawer-
  // progress rebuilds from scratch the next time the shopper opens the drawer.
  function refreshDrawer() {
    if (isDrawerOpen() && typeof window.cart_update === 'function') { window.cart_update(); return Promise.resolve(); }
    return refreshDrawerSilently();
  }

  // After an ADD we do want the drawer to open, as it does today.
  function refreshAndOpenDrawer() {
    if (typeof window.cart_update === 'function') { window.cart_update(); return; }
    refreshDrawerSilently().then(function () {
      var opener = document.querySelector('.js-drawer-open-cart, a.open-cart-drawer-new');
      if (opener) opener.click();
    });
  }

  function reinitDrawerSlick() {
    try {
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        var $c = window.jQuery('.cart-all-products');
        if ($c.length) { $c.slick({ dots: true, infinite: true, speed: 300, slidesToShow: 1, slidesToScroll: 1, arrows: true }); }
      }
    } catch (e) {}
  }

  // ------------------------------------------------------------------- init
  // Exposed for the drawer's garment remove / minus-to-0 handlers (theme-dual-merged.js)
  // so they can drop a whole bundle atomically instead of leaving a billable orphan.
  window.__embOs3 = { removeBundle: removeBundle, reconcile: schedule };

  function initReconciler() {
    reconcile();   // catch orphans already sitting in the cart on load
    var target = document.querySelector('.cart_drawer_custom');
    if (target) {
      new MutationObserver(function () { schedule(); }).observe(target, { childList: true, subtree: true });
    }
    // Timer backstop: catch anything the observer misses (races, a closed drawer,
    // strays from the old flow). Gated on domHasAddonLine() so it only reconciles
    // while there's an add-on line rendered -> ~free the rest of the time.
    setInterval(function () { if (domHasAddonLine()) schedule(); }, 4000);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initReconciler); }
  else { initReconciler(); }
})();
